import { gql } from '@apollo/client';

export const UPDATE_PLAN = gql`
    mutation updatePlan($idUser: ID!, $idPlan: ID!, $planInput: PlanInput!, $ptId: ID!){
        updatePlan(idUser: $idUser, idPlan: $idPlan, planInput: $planInput, ptId: $ptId) {
            _id
        }
    }
`;
